export default "./dist/stdassets/images/res/spinner.gif";